import { Route, Routes } from "react-router-dom";
import Layout from "./pages/Layout/Layout";
import NotFound from "./pages/NotFound/NotFound";
import Contrato from "./pages/Contrato/Contrato";
import Condiciones from "./pages/Condiciones/Condiciones";
import EnlaceCaducado from "./pages/EnlaceCaducado/EnlaceCaducado";

const App = ()=> (
  <Routes>
    <Route path="/" element={<Layout />}>
      <Route path="contrato" element={<Condiciones />} />
      <Route path="condiciones" element={<Contrato />} />
      <Route path="enlace-caducado" element={<EnlaceCaducado />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default App;
